import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from "@angular/material/table";

export const LowPerformers = {
  worstPerformance: 'Worst Performance',
  worstOverAllScore: 'Worst Overall Score'
};

@Component({
  selector: 'app-low-performers',
  templateUrl: './low-performers.component.html',
  styleUrls: ['./low-performers.component.scss']
})
export class LowPerformersComponent implements OnInit {

  dataSource: { name: string, performers: MatTableDataSource<any>}[];
  LowPerformers = LowPerformers;
  displayedColumns = ['number', 'parent', 'commodity', 'score'];

  onDownload = new EventEmitter();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<LowPerformersComponent>,
  ) {
    this.dataSource = Object.keys(data).map(item => ({name: item, performers: new MatTableDataSource(data[item])}));
    console.log(this.dataSource);
   }

  ngOnInit() {
  }

  download() {
    this.onDownload.emit(true);
  }

}
